import React from 'react';

import { ENTER, BACK, LEFT, RIGHT } from '../util/remoteButtons';
import { fireAnalytics } from './utils';

export class Error extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
        this.selectedBtn = 'No';
        this.autoNetworkCheck = null;
    }

    componentDidMount() {
        clearInterval(this.onlineStatusInterval);
        fireAnalytics("Page", "Error Page Loaded");
        var relaunch = this.refs.relaunch;
        relaunch.focus();
        this.autoNetworkCheck = setInterval(() => {
            this.checkConnection();
        }, 15000);
        window.onkeyup = (e) => {
            e.preventDefault();
            switch (e.which) {
                case RIGHT:
                    if (this.state.open) {
                        document.getElementById('No').style.background = "";
                        document.getElementById('yes').style.background = "#910048";
                        this.refs.yes.focus();
                        this.selectedBtn = 'Yes';
                    }
                    break;
                case LEFT:
                    if (this.state.open) {
                        document.getElementById('yes').style.background = "";
                        document.getElementById('No').style.background = "#910048";
                        this.refs.no.focus();
                        this.selectedBtn = 'No';
                    }
                    break;
                case ENTER:
                    if (this.state.open) {
                        if (this.selectedBtn === 'No') {
                            this.setState({ open: false })
                        }
                        if (this.selectedBtn === 'Yes') {
                            tizen.application.getCurrentApplication().exit()
                        }
                    }
                    else {
                        this.checkConnection();
                    }
                    break;
                case BACK:
                    this.setState({ open: !this.state.open });
                    setTimeout(() => {
                        if (this.state.open) {
                            this.selectedBtn = 'No';
                        }
                        else {
                            this.selectedBtn = "None";
                        }
                    }, 700);
                    break;
            }
        }
    }

    checkConnection() {
        var condition = navigator.onLine ? true : false;
        if (condition === true) {
            fireAnalytics("Network", "Network Back Online, Navigating to Player");
            clearInterval(this.autoNetworkCheck);
            this.props.history.push(`/`);
        }
        else {
            this.setState({ connection: true });
            setTimeout(() => {
                this.setState({ connection: false });
            }, 3000);
        }
        return;
    }

    render() {
        return (
            <div className="Wrapper" style={{ textAlign: 'center' }}>
                {
                    this.state.open ? <div id="models" className="reg-response-modal" style={{ position: 'absolute', zIndex: '9999' }}>
                        <div className="model" style={{ width: '40%', backgroundColor: 'black', color: 'white', borderRadius: '15px' }}>
                            <img className="Logo2" src="assets/img/blackdove-logo-2020.png" alt="" style={{ width: '50%', paddingTop: '6%' }} />
                            <h2 style={{ marginBottom: '2%' }}>Do you want to exit?</h2>
                            <button
                                ref="no"
                                id="No"
                                style={{ background: '#910048' }}
                                className="exitPopup"
                            >No
                            </button>
                            <button
                                ref="yes"
                                id="yes"
                                style={{ marginLeft: '2%' }}
                                className="exitPopup"
                            >Yes
                            </button>
                        </div></div> : null
                }
                <div className="ErrorWrapper">
                    <img className="ErrorLogo" src="assets/img/blackdove-logo-2020.png" alt="" style={window.innerWidth <= window.innerHeight ? { paddingTop: '50%' } : { paddingTop: '10%' }} />
                    <span className="ErrorInfo">
                        Network Interruption Detected
                        <br />
                        To Exit the app, press RETURN Key and select 'YES'.
                        <br />
                        OR
                        <br />
                        To Relaunch the app, press OK Key on the Remote Controller
                    </span>
                </div>
                <div
                    ref="relaunch"
                    tabIndex="1"
                    className="btn btn--round btn--dark btn--fill relaunch"
                >Relaunch
                </div>
                <div className="timedPopup" style={!this.state.connection ? { display: 'block' } : { display: 'none' }} >No Network Connection</div>
            </div>
        );
    }
}
export default Error;